<template>
  <div>
    <input
      class="w-100 mb-3"
      v-model="search"
      type="text"
      maxlength="191"
      @input="searchComputer"
    />
    <select
      class="custom-select"
      size="6"
      style="
        min-height: 120px;
        padding: 0.5rem;
        border: 0px;
        background: #ffff;
        border: 1px solid #ccc;
      "
      :disabled="loading"
      v-model="selectedComputer"
      @change="onChange"
    >
      <option v-for="(item, index) in options" :key="index" :value="item.value">
        {{ item.label }}
      </option>
    </select>
    <!-- <multiselect
      v-model="value"
      :options="options"
      searchable="true"
      @change="onChange"
    ></multiselect> -->
  </div>
</template>

<script>
// import Multiselect from "@vueform/multiselect";
import api from "@/api/index";
import { Roles } from "@/helpers/enums/Roles";
import { debounce } from "lodash";
import Swal from "sweetalert2";

export default {
  // components: {
  //   Multiselect,
  // },
  props: {
    group: {
      type: String,
      required: true,
    },
    currentSite: {
      type: String,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      computers: [],
      search: "",
      loading: false,
      selectedComputer: null,
    };
  },
  watch: {
    async group() {
      if (this.group) {
        await this.getComputers();
      } else {
        this.computers = [];
      }
    },
    groups() {
      if (!this.groups) {
        this.computers = [];
        this.value = null;
        this.selectedComputer = null;
        this.$emit("onComputerChange", this.selectedComputer);
      }
    },
  },
  computed: {
    options() {
      return this.computers.length
        ? this.computers.map((f) => {
            return {
              label: f.WindowsComputerName,
              value: f.ComputerId,
            };
          })
        : [];
    },
  },
  mounted() {
    this.getDefaultComputers();
  },
  methods: {
    searchComputer: debounce(async function (e) {
      this.loading = true;
      const res = await api.computers.searchComputer(
        e.target.value,
        this.currentSite,
        this.groups
      );
      const computerData = Array.isArray(res.data)
        ? res.data
        : res.data.entityData;
      this.computers = computerData.map((f) => {
        return {
          WindowsComputerName: f.windowsComputerName,
          ComputerId: f.computerId,
        };
      });
      this.loading = false;
    }, 1000),

    async getComputers() {
      let guid = [this.group];
      if (Array.isArray(this.group)) {
        guid = this.group;
      }
      if (
        guid &&
        guid.length > 0 &&
        typeof guid[0] !== "object" &&
        guid[0] !== null
      ) {
        const res = await api.computers.getComputerByGroups(guid);
        if (res.data.statusCode != 200) {
          let msg = res.data.message;
          msg += "<br>";
          msg += res.data.errors.join("<br>");
          Swal.fire("Error", msg, "error");
        } else {
          this.computers = res.data.entityData;
        }
      }
    },
    async getDefaultComputers() {
      const res = await api.computers.getAgscComputerList();
      this.computers = res.data;
    },
    onChange(value) {
      this.$emit("onComputerChange", this.selectedComputer);
    },
    async created() {
      let role = (
        this.$store.state.auth.user.find((f) => f.type == "role") || {}
      ).value;
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        role = Roles.AGMSAdmin;
        // role = Roles.SiteAudit;
        // role = Roles.GroupAdmin;
        // role = Roles.SiteAdmin;
      }
      if (role == Roles.GroupAdmin) {
        const groupGuid = (
          this.$store.state.auth.user.find((f) => f.type == "GroupGuid") || {}
        ).value;
        const guid = JSON.parse(groupGuid)[0];
        const res = await api.computers.getComputerByGroups(guid);
        if (res.data.statusCode != 200) {
          let msg = res.data.message;
          msg += "<br>";
          msg += res.data.errors.join("<br>");
          Swal.fire("Error", msg, "error");
        } else {
          this.computers = res.data.entityData;
        }
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped></style>
